import { ReactNode } from "react";
import { cn } from "@/lib/utils";

type Props = {
  label: string;
  // Optional supporting text shown next to the label (e.g. "según WhatsApp").
  hint?: string;
  // Tailwind background class for the group's framing — softly tints the band
  // around the columns to make the group visually distinct.
  accentClass?: string;
  // Stage id used by KanbanStageNavigator to locate this group when scrolling.
  stageId?: string;
  children: ReactNode;
};

export const KanbanGroup = ({ label, hint, accentClass, stageId, children }: Props) => {
  return (
    <div
      data-kanban-stage-id={stageId}
      className={cn(
        "flex shrink-0 flex-col gap-2 rounded-xl border border-gray-200 bg-white/40 p-2",
        accentClass
      )}
    >
      <div className="flex items-baseline gap-2 px-2">
        <span className="text-xs font-semibold uppercase tracking-wide text-gray-700">
          {label}
        </span>
        {hint ? <span className="text-[11px] text-gray-500">{hint}</span> : null}
      </div>
      <div className="flex min-h-0 flex-1 gap-3">{children}</div>
    </div>
  );
};
